import { render } from "./Customer-Service-Modal.vue?vue&type=template&id=34e47ae4"
import script from "./Customer-Service-Modal.vue?vue&type=script&lang=js"
export * from "./Customer-Service-Modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__